import React from 'react';
import { CardElement } from '@stripe/react-stripe-js';

import StripeInput from './stripeInput';
import { TextField, Typography } from '@material-ui/core';

const PaymentInfo = (props) => {
  const { onChange } = props;

  return (
    <div>
      <Typography gutterBottom={true}>Card Information</Typography>

      <TextField
        name="ccnumber"
        variant="outlined"
        required
        fullWidth
        InputLabelProps={{ shrink: true }}
        InputProps={{
          inputComponent: StripeInput,
          inputProps: {
            Component: CardElement,
            onChange: onChange,
            options: { hidePostalCode: true },
          },
        }}
      />
    </div>
  );
};
export default PaymentInfo;
